import { reactive } from "vue";

const store = {
  bot: {
    materials: 0,
    progress: 0,
    population: 0,
    nation: {
      name: "persian",
      state: "barbarian",
      canTransitionState: true,
    },
    roll: -1,
    canRoll: true,
  },
  player: {
    materials: 3,
    progress: 1,
    population: 1,
    actions: 3,
  },
  setNation(nation) {
    this.bot.nation = nation;
  },
};

export default reactive(store);
